// ----------------- FETCH SUBSCRIBER VOUCHERS -----------------
export const FETCH_SUBSCRIBER_VOUCHERS_LOADING =
	'FETCH_SUBSCRIBER_VOUCHERS_LOADING';
export const FETCH_SUBSCRIBER_VOUCHERS_SUCCESS =
	'FETCH_SUBSCRIBER_VOUCHERS_SUCCESS';
export const FETCH_SUBSCRIBER_VOUCHERS_ERROR =
	'FETCH_SUBSCRIBER_VOUCHERS_ERROR';
